import Logger from './logger';
import event from './mixins/event';
import { gsap } from "gsap";
import { Observer } from 'gsap/Observer';

gsap.registerPlugin(Observer);

class ThemeFloatingAvatar {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeFloatingAvatar';

		this.dom = dom;

		this.activeClass = `theme-floating-avatar--speaking`;

		this.messageHistory = [];

		this.speechBubbleDom = document.querySelector(`[data-theme-floating-avatar-speech-bubble]`);
	}

	/**
	 * hashMessage - Hash the message
	 */
	hashMessage(message) {
		Logger.info(`${this.NAME} > hashMessage`);

		var hash = 0,
			i, chr;
		if (message.length === 0) return hash;
		for (i = 0; i < message.length; i++) {
			chr = message.charCodeAt(i);
			hash = ((hash << 5) - hash) + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	}

	/**
	 * hasSpokenThisMessage - Check if the message has been spoken
	 */
	hasSpokenThisMessage(message) {
		Logger.info(`${this.NAME} > hasSpokenThisMessage`);

		// Hash the message and check it against the history
		var hash = this.hashMessage(message);

		if (this.messageHistory.includes(hash)) {
			return true;
		} else {
			return false;
		}
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
	}


	/**
	 * speak - Speak the message
	 */
	speak(message, duration, insureUnique) {
		Logger.info(`${this.NAME} > speak`);

		if (insureUnique && this.hasSpokenThisMessage(message)) {
			return false;
		}

		this.storeMessage(message);

		this.speechBubbleDom.innerHTML = message;

		this.dom.classList.add(this.activeClass);

		if (duration) {
			setTimeout(() => {
				this.stop();
			}, duration);
		}
	}

	/**
	 * speakRandom - Speak a random message
	 */
	speakRandom(phrases, duration, insureUnique) {
		Logger.info(`${this.NAME} > speakRandom`);

		const randomIndex = Math.floor(Math.random() * phrases.length);
		const randomPhrase = phrases[randomIndex];

		this.speak(randomPhrase, duration, insureUnique);
	}

	/**
	 * storeMessage - Store the message hash
	 */
	storeMessage(message) {
		Logger.info(`${this.NAME} > storeMessage`);

		// Hash the message and store it
		const hash = this.hashMessage(message);
		this.messageHistory.push(hash);
	}

	/**
	 * stop - Hide the message
	 */
	stop() {
		Logger.info(`${this.NAME} > stop`);
		this.dom.classList.remove(this.activeClass);
	}
}

Object.assign(ThemeFloatingAvatar.prototype, event);

export default ThemeFloatingAvatar;
